<ng-container *ngIf="user">
  <app-toolbar [user]="user" [title]="title" [back]="true" [destination]=""></app-toolbar>
</ng-container>


<h2 style="text-align: center; padding-top: 20px; padding-bottom: 20px">Pazienti registrati</h2>

<div class="container && mat-elevation-z5">

  <ng-container *ngIf="patients && patients.length > 0; else noPatientRegistered">

    <div style="text-align: center; padding-top: 10px; padding-bottom: 10px">
      <mat-form-field style="min-width: 400px">
        <mat-label>Filtra risultati</mat-label>
        <input matInput (keyup)="applyFilter($event)" placeholder="Filtra">
      </mat-form-field>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      <mat-checkbox (change)="selectNoClinicalDataPatients($event)">Mostra solo i pazienti con dati clinici mancanti</mat-checkbox>
    </div>

    <table *ngIf="noClinicalDataSelection === false" mat-table [dataSource]="dataSource">

      <ng-container matColumnDef="surname">
        <th mat-header-cell *matHeaderCellDef> Cognome </th>
        <td mat-cell *matCellDef="let patient"> {{patient.surname}} </td>
      </ng-container>

      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef> Nome </th>
        <td mat-cell *matCellDef="let patient">{{patient.name}}</td>
      </ng-container>

      <ng-container matColumnDef="ssn">
        <th mat-header-cell *matHeaderCellDef> Codice fiscale </th>
        <td mat-cell *matCellDef="let patient"> {{patient.ssn}} </td>
      </ng-container>

      <ng-container matColumnDef="doctor">
        <th mat-header-cell *matHeaderCellDef> Curante </th>
        <td mat-cell *matCellDef="let patient"> {{patient.doctor.surname}} {{patient.doctor.name}} </td>
      </ng-container>

      <ng-container matColumnDef="category">
        <th mat-header-cell *matHeaderCellDef> Gruppo </th>
        <td mat-cell *matCellDef="let patient"> {{patient.category}} </td>
      </ng-container>

      <ng-container matColumnDef="card">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let patient">
         <ng-container *ngIf="this.controlClinicalData(patient) === false">
           <span><button mat-button mat-icon-button matTooltip="Visualizza scheda paziente" color="primary" (click)="openPanel(patient)"><mat-icon>perm_identity</mat-icon></button></span>
           <mat-icon class="icon" matTooltip="Dati clinici mancanti" style="color: #ffa500">warning</mat-icon>
         </ng-container>
          <ng-container *ngIf="this.controlClinicalData(patient) === true">
            <span><button mat-button mat-icon-button matTooltip="Visualizza scheda paziente" color="primary" (click)="openPanel(patient)"><mat-icon>perm_identity</mat-icon></button></span>
          </ng-container>
        </td>
      </ng-container>

      <ng-container matColumnDef="questionnaires">
        <th mat-header-cell *matHeaderCellDef><!-- Questionari--></th>
        <td mat-cell *matCellDef="let patient">
          <span><button mat-button mat-icon-button matTooltip="Visualizza questionari compilati" color="primary" (click)="goToQuestionnaires(patient.ssn)"><mat-icon>assignment</mat-icon></button></span>
        </td>
      </ng-container>

      <ng-container matColumnDef="email">
        <th mat-header-cell *matHeaderCellDef><!-- Email--></th>
        <td mat-cell *matCellDef="let patient">
          <span><a href="mailto:{{patient.email}}"><button mat-button mat-icon-button matTooltip="Invia una e-mail" color="primary"><mat-icon>email</mat-icon></button></a></span>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
    <table *ngIf="noClinicalDataSelection === true" mat-table [dataSource]="dataSourceNoClinicalData">

      <ng-container matColumnDef="surname">
        <th mat-header-cell *matHeaderCellDef> Cognome </th>
        <td mat-cell *matCellDef="let patient"> {{patient.surname}} </td>
      </ng-container>

      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef> Nome </th>
        <td mat-cell *matCellDef="let patient">{{patient.name}}</td>
      </ng-container>

      <ng-container matColumnDef="ssn">
        <th mat-header-cell *matHeaderCellDef> Codice fiscale </th>
        <td mat-cell *matCellDef="let patient"> {{patient.ssn}} </td>
      </ng-container>

      <ng-container matColumnDef="doctor">
        <th mat-header-cell *matHeaderCellDef> Curante </th>
        <td mat-cell *matCellDef="let patient"> {{patient.doctor.surname}} {{patient.doctor.name}} </td>
      </ng-container>

      <ng-container matColumnDef="category">
        <th mat-header-cell *matHeaderCellDef> Gruppo </th>
        <td mat-cell *matCellDef="let patient"> {{patient.category}} </td>
      </ng-container>

      <ng-container matColumnDef="card">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let patient">
          <span><button mat-button mat-icon-button matTooltip="Visualizza scheda paziente" color="primary" (click)="openPanel(patient)"><mat-icon>perm_identity</mat-icon></button></span>
        </td>
      </ng-container>

      <ng-container matColumnDef="questionnaires">
        <th mat-header-cell *matHeaderCellDef><!-- Questionari--></th>
        <td mat-cell *matCellDef="let patient">
          <span><button mat-button mat-icon-button matTooltip="Visualizza questionari compilati" color="primary" (click)="goToQuestionnaires(patient.ssn)"><mat-icon>assignment</mat-icon></button></span>
        </td>
      </ng-container>

      <ng-container matColumnDef="email">
        <th mat-header-cell *matHeaderCellDef><!-- Email--></th>
        <td mat-cell *matCellDef="let patient">
          <span><a href="mailto:{{patient.email}}"><button mat-button mat-icon-button matTooltip="Invia una e-mail" color="primary"><mat-icon>email</mat-icon></button></a></span>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
  </ng-container>

  <mat-paginator style="padding: 20px; text-align: center" [pageSizeOptions]="[5, 10, 25, 100]"
                 [length]="totalSize"
                 [pageSize]="5">showFirstLastButtons></mat-paginator>

</div>

<ng-template #noPatientRegistered>
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
</ng-template>
<div style="text-align: center; padding-top:60px; padding-bottom: 20px;">
  <p style="font-size: 17px; font-weight: bold; ">Registra un nuovo paziente:</p>
  <button mat-raised-button color="primary" routerLink="/patient-registration">Registra</button>
</div>

